import { CustomEventWithDetail, html, on, View } from 'rune-ts';
import klass from './slider.module.scss';
import { cx, cxIf, cxQs } from '../util/cx.ts';
import { debounce } from 'fxjs/es';

export interface SliderParams {
  value: number;
  disabled: boolean;
}

export class ChangeRangeEvent extends CustomEventWithDetail<{ slider_value: number }> {}
export class InputRangeEvent extends CustomEventWithDetail<{ slider_value: number }> {}

export class SliderView extends View<SliderParams> {
  private current_value = this.data.value;

  private changeEventDebouncer = debounce(() => {
    this.dispatchEvent(ChangeRangeEvent, {
      bubbles: true,
      detail: {
        slider_value: this.data.value,
      },
    });
  }, 300);

  get currentValue() {
    return this.current_value;
  }

  override template() {
    const { value, disabled } = this.data;
    return html`
      <div class="${cx(klass.slidercontainer, cxIf(disabled, klass.disabled))}">
        <input type="range" class="${cx(klass.sliderrange)}" min="0" max="1" step="0.01" value="${value}" />
      </div>
    `;
  }

  @on('input', cxQs(klass.sliderrange))
  _input(event: Event) {
    const input = event.target as HTMLInputElement;

    const value = parseFloat(input.value);
    this.updateRangeValue(value);

    this.data.value = value;

    // 슬라이더 변화 시 인풋 업데이트 되어야함
    this.dispatchEvent(InputRangeEvent, {
      bubbles: true,
      detail: {
        slider_value: this.data.value,
      },
    });
  }

  @on('change', cxQs(klass.sliderrange))
  mouseup(_event: Event) {
    // 슬라이더에서 마우스 뗀 경우 이미지 크기 변경
    this.changeEventDebouncer();
  }

  override onRender() {
    this.updateRangeValue(this.data.value);

    const input = this.element().querySelector(cxQs(klass.sliderrange));
    if (input) {
      input.addEventListener('mousedown', this._handleSliderDragStart);
      input.addEventListener('touchstart', this._handleSliderDragStart);

      input.addEventListener('keydown', (e) => {
        const event = e as KeyboardEvent;
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }

  private updateRangeValue(value: number) {
    const input = this.element().querySelector(cxQs(klass.sliderrange)) as HTMLElement;
    return input.style.setProperty('--range-progress', `${(value / 1) * 100 || 0}%`);
  }

  private _handleSliderDragStart = () => {
    window.addEventListener('mouseup', this._handleSliderDragEnd);
    window.addEventListener('touchend', this._handleSliderDragEnd);
  };

  private _handleSliderDragEnd = () => {
    this.changeEventDebouncer();
    window.removeEventListener('mouseup', this._handleSliderDragEnd);
    window.removeEventListener('touchend', this._handleSliderDragEnd);
  };
}
